module.exports = __webpack_public_path__ + "img/IND.e9d79345.svg";